import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { flatten } from "lodash";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import cardLoadColumns from "./cardLoadColumns";

type Props = {
  search: string;
  name: string;
};

const query = gql`
  query Currentlist($search: String, $offset: Int, $limit: Int) {
    users(search: $search, offset: $offset, limit: $limit) {
      bank_card_changes {
        created_at
        auth_reference
        authorization_code
        bin
        bin_info
        callback_url
        country_code
        external_reference
        message
        psp
        psp_reference
        secure3d_requested
        secure3d_verified
        snapmin_url
        status
        device {
          phone_number
          external_reference
          snapmin_url
          user {
            email
            external_reference
            snapmin_url
          }
        }
      }
    }
  }
`;

const withData = graphql<any, Props & PaginationProps>(query, {
  options: ({ search, pagination: { offset, limit } }) => ({
    fetchPolicy: "network-only",
    variables: {
      search,
      offset,
      limit,
    },
  }),
});

export default withPagination(
  withData((props) => {
    const flattened = (usersWithCardLoads: any[]) => {
      const cardLoads = usersWithCardLoads.map(
        (user) => user.bank_card_changes
      );

      return flatten(cardLoads);
    };

    return (
      <BOGraphQLLoader data={props.data}>
        <ConfigurableTable
          columnConfigs={cardLoadColumns}
          defaultColumns={[
            "Date",
            "BIN",
            "Country code",
            "User",
            "Secure 3D",
            "Device",
          ]}
          rows={(props.data.users && flattened(props.data.users)) || []}
          pagination={props.pagination}
          name={props.name}
        />
      </BOGraphQLLoader>
    );
  })
);
